import * as React from "react";
import { useAccountSettings, useCoachSettings } from "@/utils";
import { CoachSettings, SubscribedPlayerSearchResponse, WebComponents } from "@/interfaces";
import {
  PlayerShortLinkForm,
  PlayerStickersForm,
  PlayerHashTagsForm,
  PlayerComplianceForm,
} from "@/containers/Coach/EditPlayer/components";

interface PlayerFormProps {
  player: SubscribedPlayerSearchResponse;
  reloadPlayer: () => void;
  clearCaches: () => void;
}

export function PlayerCustomizationsTab({ player, reloadPlayer, clearCaches }: PlayerFormProps) {
  const playerId = player.playerAccount.playerId!;
  const { hasWritePermission } = useAccountSettings();
  const { hasSetting } = useCoachSettings();
  const withWritePermission = hasWritePermission(WebComponents.PLAYERS);
  const showCustomStickersSection = hasSetting(CoachSettings.PLAYER_CUSTOM_STICKERS, true);
  const showHashTagSection = hasSetting(CoachSettings.PLAYER_HASHTAG, true);

  return (
    <div className="w-full max-w-5xl">
      <div className={"grid grid-cols-2 gap-6"}>
        <PlayerShortLinkForm playerId={playerId} />

        {showCustomStickersSection && (
          <PlayerStickersForm playerId={playerId} withWritePermission={withWritePermission} />
        )}

        {showHashTagSection && <PlayerHashTagsForm playerId={playerId} />}

        <PlayerComplianceForm player={player} reloadPlayer={reloadPlayer} clearCaches={clearCaches} />
      </div>
    </div>
  );
}
